import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import InputField from "../../../components/InputField";
import Button from "../../../components/Button";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Modal } from "react-bootstrap";
import "../../Freight/Common/form.css";
import Select from "react-select";
import api from "../../../api/api";
import { useAuth } from "../../../context/AuthContext";
import Breadcrumbs from "../../../components/Breadcrumbs";
 
const CreateEnquirySales = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
 
  const [formData, setFormData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [inputRow, setInputRow] = useState({
    containerType: "",
    weight: "",
    length: "",
    breadth: "",
    height: "",
    temperature: "",
  });
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});
 
  const containerOptions = [
    { value: "20'Standard", label: "20'Standard" },
    { value: "20'Open Top", label: "20'Open Top" },
    { value: "20'Reefer", label: "20'Reefer" },
    { value: "20'Flat Rack", label: "20'Flat Rack" },
    { value: "20'Platform", label: "20'Platform" },
    { value: "20'Flexi Tank", label: "20'Flexi Tank" },
    { value: "20'ISO Tank", label: "20'ISO Tank" },
    { value: "20'Hard Top", label: "20'Hard Top" },
    { value: "20'Collapsible", label: "20'Collapsible" },
    { value: "40'Standard", label: "40'Standard" },
    { value: "40'High Cube", label: "40'High Cube" },
    { value: "40'Open top", label: "40'Open top" },
    { value: "40'Reefer", label: "40'Reefer" },
    { value: "40'Flat Rack", label: "40'Flat Rack" },
    { value: "40'Platform", label: "40'Platform" },
    { value: "40'Flexi Tank", label: "40'Flexi Tank" },
    { value: "40'ISO Tank", label: "40'ISO Tank" },
    { value: "40'Hard Top", label: "40'Hard Top" },
    { value: "40'Collapsible Flat Rack", label: "40'Collapsible Flat Rack" },
  ];
 
  const incotermOptions = [
    "Port to Port",
    "Door to Door",
    "Door to Port",
    "Port to Door",
    "ICD to Port",
    "ICD to Door",
  ];
 
  const shipmentSegmentOptions = ["FE", "LE", "FI", "LI"];
  const natureOfCargoOptions = [
    "Hazardous",
    "Non Hazardous",
    "Temperature Control",
    "Moisture Control",
    "Heavy Duty",
    "Over Dimensional Cargo",
  ];
  const documentTypeOptions = ["Original", "Seaway"];
  const switchBlOptions = ["No", "Yes"];
  const freighttermsOptions = ["Prepaid", "Collect"];
 
  const [portsOptions, setPortsOptions] = useState([]);
 
  // Normalize string for matching
  const normalize = (str) =>
    str ? str.trim().toLowerCase().replace(/\s+/g, " ") : "";
 
  // Fetch enquiry details
  const fetchData = async () => {
    try {
      const res = await api.get(`/enquiry/viewEnquiry/${id}`);
      setFormData(res.data);
      setTableData(
        res.data.containerDetails?.map((c) => ({
          container_id: c.container_id, // preserve existing container_id
          container_type: c.container_type,
          container_weight: c.container_weight,
          container_length: c.container_length,
          container_breadth: c.container_breadth,
          container_height: c.container_height,
          container_temperature: c.container_temperature,
        })) || []
      );
    } catch (error) {
      console.error("Error fetching enquiry:", error);
    } finally {
      setLoading(false);
    }
  };
 
  // Fetch ports for dropdown
  const fetchPorts = async () => {
    try {
      const res = await api.get("/ports");
      // console.log("res", res.data);
 
      const options = res.data.map((p) => ({
        value: p.Port_names,
        label: p.Port_names,
      }));
 
      // console.log("options", options);
      setPortsOptions(options);
    } catch (err) {
      console.error("Error fetching ports:", err);
    }
  };
 
  // console.log("portsOptions", portsOptions);
 
  useEffect(() => {
    fetchData();
    fetchPorts();
  }, []);
 
  const handleFormChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };
 
  const handleInputChange = (field, value) => {
    setInputRow((prev) => ({ ...prev, [field]: value }));
  };
 
  const handleAddRow = () => {
    if (
      !inputRow.containerType &&
      formData.shipment_segment !== "LE" &&
      formData.shipment_segment !== "LI"
    ) {
      return;
    }
 
    const newContainer = {
      container_type: inputRow.containerType,
      container_weight: inputRow.weight,
      container_length: inputRow.length,
      container_breadth: inputRow.breadth,
      container_height: inputRow.height,
      container_temperature: inputRow.temperature,
    };
 
    setTableData((prev) => [...prev, newContainer]);
    setInputRow({
      containerType: "",
      weight: "",
      length: "",
      breadth: "",
      height: "",
      temperature: "",
    });
  };
 
  const handleRemoveRow = (index) => {
    setTableData((prev) => prev.filter((_, i) => i !== index));
  };
 
  const validateForm = () => {
    const newErrors = {};
 
    if (!formData.client_name)
      newErrors.client_name = "Booking Party Name is required";
    if (!formData.client_company)
      newErrors.client_company = "Booking Company Name is required";
    if (!formData.cha_required)
      newErrors.cha_required = "CHA Required is required";
    if (!formData.incoterm) newErrors.incoterm = "Incoterm is required";
    if (!formData.pol) newErrors.pol = "Port of Loading is required";
    if (!formData.pod) newErrors.pod = "Port of Discharge is required";
    if (!formData.freight_terms)
      newErrors.freight_terms = "Freight Terms is required";
    if (!formData.shipment_segment)
      newErrors.shipment_segment = "Shipment Segment is required";
    if (!formData.nature_of_cargo)
      newErrors.nature_of_cargo = "Nature of Cargo is required";
    if (!formData.document_type)
      newErrors.document_type = "Document Type is required";
    if (!formData.hs_code) newErrors.hs_code = "HS Code is required";
    if (!formData.hs_description)
      newErrors.hs_description = "HS Description is required";
    if (tableData.length === 0)
      newErrors.containers = "At least one container is required";
    if (!formData.packaging_type)
      newErrors.packaging_type = "Packaging Type is required";
    if (!formData.packaging_count)
      newErrors.packaging_count = "Packaging Count is required";
    if (!formData.goods_value)
      newErrors.goods_value = "Goods value is required";
    // if (!formData.remarks) newErrors.remarks = "Remarks is required";
 
    // Conditional validations
    if (
      ["Door to Door", "ICD to Door", "Door to Port", "ICD to Port"].includes(
        formData.incoterm
      )
    ) {
      if (!formData.place_of_receipt) newErrors.place_of_receipt = "Place Of Receipt is required";
      if (!formData.place_of_receipt_pin)
        newErrors.place_of_receipt_pin = "POR Pin Code is required";
    }
    if (
      ["Door to Door", "ICD to Door", "Port to Door"].includes(
        formData.incoterm
      )
    ) {
      if (!formData.final_port_of_delivery) newErrors.final_port_of_delivery = "Final Port Of Delivery is required";
      if (!formData.final_port_of_delivery_pin)
        newErrors.final_port_of_delivery_pin = "FPOD Pin Code is required";
    }
    if (
      ["FE", "LE"].includes(formData.shipment_segment) &&
      !formData.stuffing_destuffing_At
    ) {
      newErrors.stuffing_destuffing_At = "Stuffing At is required";
    }
    if (
      ["FI", "LI"].includes(formData.shipment_segment) &&
      !formData.stuffing_destuffing_At
    ) {
      newErrors.stuffing_destuffing_At = "Destuffing At is required";
    }
    if (formData.nature_of_cargo === "Hazardous" && !formData.haz_class) {
      newErrors.haz_class = "HAZ Class is required";
    }
    if (formData.document_type === "Original") {
      if (!formData.document_count) {
        newErrors.document_count = "Document Count is required";
      } else if (isNaN(formData.document_count)) {
        newErrors.document_count = "Document Count must be a number";
      }
    }
    if (!formData.switch_bl || !formData.switch_at) {
      newErrors.switch_at = "Switch At is required when Switch BL is Yes";
    }
 
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
 
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setShowConfirm(true);
    }
  };
 
  const handleConfirm = async () => {
    try {
      const dataToSend = {
        ...formData,
        containers: tableData,
        document_count: formData.document_count
          ? parseInt(formData.document_count, 10)
          : null,
        packaging_count: formData.packaging_count
          ? parseInt(formData.packaging_count, 10)
          : null,
      };
      await api.put(`/create-enquiry-sales/${id}`, dataToSend);
      setShowConfirm(false);
      setShowSuccess(true);
    } catch (err) {
      console.error("Error updating enquiry:", err);
      setShowConfirm(false);
    }
  };
 
  const handleSuccessClose = () => {
    setShowSuccess(false);
    if (user?.user_role === "User") {
      navigate("/my-enquiry/view-enquiry");
    } else if (user?.user_role === "sales_rep") {
      navigate("/freight-enquiries");
    } else {
      navigate("/my-enquiry/view-enquiry");
    }
  };
 
  if (loading || !formData)
    return <p className="text-center mt-4">Loading enquiry...</p>;
 
  return (
    <>
      <Breadcrumbs />
      <form onSubmit={handleSubmit}>
        <div className="row g-3">
          {/* Booking Party Name */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Booking Party Name</label>
            <InputField
              value={formData.client_name || ""}
              onChange={(e) => handleFormChange("client_name", e.target.value)}
            />
            {errors.client_name && (
              <div className="errormessage">{errors.client_name}</div>
            )}
          </div>
 
{/* Booking Company Name */}
           <div className="col-sm-6 col-md-4">
             <label className="form-label">Booking Company Name</label>
            <InputField
              value={formData.client_company || ""}
              onChange={(e) =>
                handleFormChange("client_company", e.target.value)
              }
            />
            {errors.client_company && (
              <div className="errormessage">{errors.client_company}</div>
            )}
          </div>
 
          {/* Incoterm */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Incoterm</label>
            <Select
              placeholder="Select Incoterm"
              options={incotermOptions.map((i) => ({ value: i, label: i }))}
              value={
                formData.incoterm
                  ? { value: formData.incoterm, label: formData.incoterm }
                  : null
              }
              onChange={(opt) => handleFormChange("incoterm", opt?.value)}
              isClearable
            />
            {errors.incoterm && (
              <div className="errormessage">{errors.incoterm}</div>
            )}
          </div>
 
          {/* Port of Loading */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Port of Loading</label>
            <Select
              options={portsOptions}
              value={(() => {
                const polOption = portsOptions.find(
                  (p) => normalize(p.value) === normalize(formData.pol)
                );
                return (
                  polOption ||
                  (formData.pol
                    ? { value: formData.pol, label: formData.pol }
                    : null)
                );
              })()}
              onChange={(opt) => handleFormChange("pol", opt?.value)}
              isClearable
            />
            {errors.pol && <div className="errormessage">{errors.pol}</div>}
          </div>
 
          {/* Port of Discharge */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Port of Discharge</label>
            <Select
              options={portsOptions}
              value={(() => {
                const podOption = portsOptions.find(
                  (p) => normalize(p.value) === normalize(formData.pod)
                );
                return (
                  podOption ||
                  (formData.pod
                    ? { value: formData.pod, label: formData.pod }
                    : null)
                );
              })()}
              onChange={(opt) => handleFormChange("pod", opt?.value)}
              isClearable
            />
            {errors.pod && <div className="errormessage">{errors.pod}</div>}
          </div>
 
          {/* Freight Terms */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Freight Terms</label>
            <Select
              placeholder="Select Freight Terms"
              options={freighttermsOptions.map((i) => ({ value: i, label: i }))}
              value={
                formData.freight_terms
                  ? {
                      value: formData.freight_terms,
                      label: formData.freight_terms,
                    }
                  : null
              }
              onChange={(opt) => handleFormChange("freight_terms", opt?.value)}
              isClearable
            />
            {errors.freight_terms && (
              <div className="errormessage">{errors.freight_terms}</div>
            )}
          </div>
 
          {/* Pickup & Dropoff */}
          {[
            "Door to Door",
            "ICD to Door",
            "Door to Port",
            "ICD to Port",
          ].includes(formData.incoterm) && (
            <>
              <div className="col-sm-6 col-md-4">
                <label className="form-label">Pickup Location</label>
                <InputField
                  placeholder="Pickup Location"
                  value={formData.place_of_receipt}
                  onChange={(e) => handleFormChange("place_of_receipt", e.target.value)}
                />
                {errors.place_of_receipt && <div className="errormessage">{errors.place_of_receipt}</div>}
              </div>
              <div className="col-sm-6 col-md-4">
                <label className="form-label">Pickup Pincode</label>
                <InputField
                  placeholder="Pickup Pincode"
                  value={formData.place_of_receipt_pin}
                  onChange={(e) =>
                    handleFormChange("place_of_receipt_pin", e.target.value)
                  }
                />
                {errors.place_of_receipt_pin && (
                  <div className="errormessage">{errors.place_of_receipt_pin}</div>
                )}
              </div>
            </>
          )}
          {["Door to Door", "ICD to Door", "Port to Door"].includes(
            formData.incoterm
          ) && (
            <>
              <div className="col-sm-6 col-md-4">
                <label className="form-label">Dropoff Location</label>
                <InputField
                  placeholder="Dropoff Location"
                  value={formData.final_port_of_delivery}
                  onChange={(e) => handleFormChange("final_port_of_delivery", e.target.value)}
                />
                {errors.final_port_of_delivery && <div className="errormessage">{errors.final_port_of_delivery}</div>}
              </div>
              <div className="col-sm-6 col-md-4">
                <label className="form-label">Dropoff Pincode</label>
                <InputField
                  placeholder="Dropoff Pincode"
                  value={formData.final_port_of_delivery_pin}
                  onChange={(e) =>
                    handleFormChange("final_port_of_delivery_pin", e.target.value)
                  }
                />
                {errors.final_port_of_delivery_pin && (
                  <div className="errormessage">{errors.final_port_of_delivery_pin}</div>
                )}
              </div>
            </>
          )}
 
          {/* Shipment Segment */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Shipment Segment</label>
            <Select
              placeholder="Select Segment"
              options={shipmentSegmentOptions.map((i) => ({
                value: i,
                label: i,
              }))}
              value={
                formData.shipment_segment
                  ? {
                      value: formData.shipment_segment,
                      label: formData.shipment_segment,
                    }
                  : null
              }
              onChange={(opt) =>
                handleFormChange("shipment_segment", opt?.value)
              }
              isClearable
            />
            {errors.shipment_segment && (
              <div className="errormessage">{errors.shipment_segment}</div>
            )}
          </div>
 
          {/* Stuffing/Destuffing */}
          {["FE", "LE"].includes(formData.shipment_segment) && (
            <div className="col-sm-6 col-md-4">
              <label className="form-label">Stuffing At</label>
              <InputField
                placeholder="Stuffing At"
                value={formData.stuffing_destuffing_At || ""}
                onChange={(e) =>
                  handleFormChange("stuffing_destuffing_At", e.target.value)
                }
              />
              {errors.stuffing_destuffing_At && (
                <div className="errormessage">
                  {errors.stuffing_destuffing_At}
                </div>
              )}
            </div>
          )}
          {["FI", "LI"].includes(formData.shipment_segment) && (
            <div className="col-sm-6 col-md-4">
              <label className="form-label">Destuffing At</label>
              <InputField
                placeholder="Destuffing At"
                value={formData.stuffing_destuffing_At}
                onChange={(e) =>
                  handleFormChange("stuffing_destuffing_At", e.target.value)
                }
              />
              {errors.stuffing_destuffing_At && (
                <div className="errormessage">
                  {errors.stuffing_destuffing_At}
                </div>
              )}
            </div>
          )}
          {/* Nature of Cargo */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Nature of Cargo</label>
            <Select
              placeholder="Select Cargo Type"
              options={natureOfCargoOptions.map((i) => ({
                value: i,
                label: i,
              }))}
              value={
                formData.nature_of_cargo
                  ? {
                      value: formData.nature_of_cargo,
                      label: formData.nature_of_cargo,
                    }
                  : null
              }
              onChange={(opt) =>
                handleFormChange("nature_of_cargo", opt?.value)
              }
              isClearable
            />
            {errors.nature_of_cargo && (
              <div className="errormessage">{errors.nature_of_cargo}</div>
            )}
          </div>
 
          {formData.nature_of_cargo === "Hazardous" && (
            <div className="col-sm-6 col-md-4">
              <label className="form-label">HAZ Class</label>
              <Select
                placeholder="Select HAZ Class"
                options={[
                  { value: "Class 1", label: "Class 1" },
                  { value: "Class 2", label: "Class 2" },
                  { value: "Class 3", label: "Class 3" },
                  { value: "Class 4", label: "Class 4" },
                  { value: "Class 5", label: "Class 5" },
                  { value: "Class 6", label: "Class 6" },
                  { value: "Class 7", label: "Class 7" },
                  { value: "Class 8", label: "Class 8" },
                  { value: "Class 9", label: "Class 9" },
                ]}
                value={
                  formData.haz_class
                    ? { value: formData.haz_class, label: formData.haz_class }
                    : null
                }
                onChange={(opt) => handleFormChange("haz_class", opt?.value)}
                isClearable
              />
              {errors.haz_class && (
                <div className="errormessage">{errors.haz_class}</div>
              )}
            </div>
          )}
 
          {/* Document Type */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Document Type</label>
            <Select
              placeholder="Select Document Type"
              options={documentTypeOptions.map((i) => ({ value: i, label: i }))}
              value={
                formData.document_type
                  ? {
                      value: formData.document_type,
                      label: formData.document_type,
                    }
                  : null
              }
              onChange={(opt) => handleFormChange("document_type", opt?.value)}
              isClearable
            />
            {errors.document_type && (
              <div className="errormessage">{errors.document_type}</div>
            )}
          </div>
 
          {formData.document_type === "Original" && (
            <div className="col-sm-6 col-md-4">
              <label className="form-label">Document Count</label>
              <InputField
                placeholder="Enter Document Count"
                value={formData.document_count}
                onChange={(e) =>
                  handleFormChange("document_count", e.target.value)
                }
              />
              {errors.document_count && (
                <div className="errormessage">{errors.document_count}</div>
              )}
            </div>
          )}
 
          {formData.document_type && (
            <div className="col-sm-6 col-md-4">
              <label className="form-label">Switch BL</label>
              <Select
                placeholder="Select Switch BL"
                options={switchBlOptions.map((i) => ({ value: i, label: i }))}
                value={
                  formData.switch_bl
                    ? {
                        value: formData.switch_bl,
                        label: formData.switch_bl,
                      }
                    : null
                }
                onChange={(opt) => handleFormChange("switch_bl", opt?.value)}
                isClearable
              />
              {errors.switch_bl && (
                <div className="errormessage">{errors.switch_bl}</div>
              )}
            </div>
          )}

          {formData.switch_bl === "Yes" && (
            <div className="col-sm-6 col-md-4">
              <label className="form-label">Switch BL At</label>
              <Select
                options={portsOptions}
                value={(() => {
                  const switchAtOption = portsOptions.find(
                    (p) => normalize(p.value) === normalize(formData.switch_at)
                  );
                  return (
                    switchAtOption ||
                    (formData.switch_at
                      ? { value: formData.switch_at, label: formData.switch_at }
                      : null)
                  );
                })()}
                onChange={(opt) => handleFormChange("switch_at", opt?.value)}
                isClearable
              />
              {errors.switch_at && (
                <div className="errormessage">{errors.switch_at}</div>
              )}
            </div>
          )}
 
          {/* HS Code & Description */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">HS Code</label>
            <InputField
              placeholder="Enter HS Code"
              value={formData.hs_code}
              onChange={(e) => handleFormChange("hs_code", e.target.value)}
            />
            {errors.hs_code && (
              <div className="errormessage">{errors.hs_code}</div>
            )}
          </div>
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Cargo/HSN Description</label>
            <InputField
              placeholder="Enter Cargo/HSN Description"
              value={formData.hs_description}
              onChange={(e) =>
                handleFormChange("hs_description", e.target.value)
              }
            />
            {errors.hs_description && (
              <div className="errormessage">{errors.hs_description}</div>
            )}
          </div>
 
          {/* Container Table */}
          <div className=" mb-4 position-relative">
            <div className="position-absolute measurement d-none d-lg-block">
              <p>1M = 100CM</p>
              <p>1CM = 10MM</p>
            </div>
            <div className="ovrflw">
              <table className="table table-bordered tbllbl mb-2 mb-md-3">
                <thead className="table-light">
                  <tr>
                    {formData.shipment_segment !== "LE" &&
                      formData.shipment_segment !== "LI" && (
                        <th>Container Type</th>
                      )}
                    <th>Weight</th>
                    <th>Length</th>
                    <th>Breadth</th>
                    <th>Height</th>
                    {formData.nature_of_cargo === "Temperature Control" && (
                      <th>Temperature</th>
                    )}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {formData.shipment_segment !== "LE" &&
                      formData.shipment_segment !== "LI" && (
                        <td>
                          <Select
                            value={
                              inputRow.containerType
                                ? {
                                    value: inputRow.containerType,
                                    label: inputRow.containerType,
                                  }
                                : null
                            }
                            onChange={(opt) =>
                              handleInputChange("containerType", opt?.value)
                            }
                            options={containerOptions}
                            placeholder="Select Container"
                            isClearable
                          />
                        </td>
                      )}
                    <td>
                      <InputField
                        value={inputRow.weight}
                        type="number"
                        placeholder="Weight in kg's"
                        onChange={(e) =>
                          handleInputChange("weight", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <InputField
                        value={inputRow.length}
                        type="number"
                        placeholder="Length in cm's"
                        onChange={(e) =>
                          handleInputChange("length", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <InputField
                        value={inputRow.breadth}
                        type="number"
                        placeholder="Breadth in cm's"
                        onChange={(e) =>
                          handleInputChange("breadth", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <InputField
                        value={inputRow.height}
                        type="number"
                        placeholder="Height in cm's"
                        onChange={(e) =>
                          handleInputChange("height", e.target.value)
                        }
                      />
                    </td>
                    {formData.nature_of_cargo === "Temperature Control" && (
                      <td>
                        <InputField
                          value={inputRow.temperature}
                          type="number"
                          placeholder="Temperature in °C"
                          onChange={(e) =>
                            handleInputChange("temperature", e.target.value)
                          }
                        />
                      </td>
                    )}
                    <td className="text-center">
                      <AddCircleOutlineIcon
                        style={{
                          cursor: "pointer",
                          color: "green",
                          fontSize: 28,
                        }}
                        onClick={handleAddRow}
                      />
                    </td>
                  </tr>
                  {tableData.map((container, index) => (
                    <tr key={index}>
                      {formData.shipment_segment !== "LE" &&
                        formData.shipment_segment !== "LI" && (
                          <td>{container.container_type}</td>
                        )}
                      <td>{container.container_weight}</td>
                      <td>{container.container_length}</td>
                      <td>{container.container_breadth}</td>
                      <td>{container.container_height}</td>
                      {formData.nature_of_cargo === "Temperature Control" && (
                        <td>{container.container_temperature}</td>
                      )}
                      <td className="text-center">
                        <DeleteOutlineIcon
                          style={{
                            cursor: "pointer",
                            color: "red",
                            fontSize: 28,
                          }}
                          onClick={() => handleRemoveRow(index)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {errors.containers && (
                <div className="errormessage">{errors.containers}</div>
              )}
            </div>
          </div>
 
          {/* Packaging & Remarks */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Packaging Type</label>
            <InputField
              placeholder="Enter Packaging Type "
              value={formData.packaging_type}
              onChange={(e) =>
                handleFormChange("packaging_type", e.target.value)
              }
            />
            {errors.packaging_type && (
              <div className="errormessage">{errors.packaging_type}</div>
            )}
          </div>
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Packaging Count</label>
            <InputField
              placeholder="Enter Packaging Count "
              value={formData.packaging_count}
              onChange={(e) =>
                handleFormChange("packaging_count", e.target.value)
              }
            />
            {errors.packaging_count && (
              <div className="errormessage">{errors.packaging_count}</div>
            )}
          </div>
 
          {/* CHA Required */}
          <div className="col-sm-6 col-md-4">
            <label className="form-label">CHA Required</label>
            <Select
              placeholder="Select Yes/No"
              options={[
                { value: "Yes", label: "Yes" },
                { value: "No", label: "No" },
              ]}
              value={
                formData.cha_required
                  ? {
                      value: formData.cha_required,
                      label: formData.cha_required,
                    }
                  : null
              }
              onChange={(opt) => handleFormChange("cha_required", opt?.value)}
              isClearable
            />
            {errors.cha_required && (
              <div className="errormessage">{errors.cha_required}</div>
            )}
          </div>
 
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Goods Value</label>
            <InputField
              placeholder="Enter Goods Value"
              value={formData.goods_value}
              onChange={(e) => handleFormChange("goods_value", e.target.value)}
            />
            {errors.goods_value && (
              <div className="errormessage">{errors.goods_value}</div>
            )}
          </div>
          <div className="col-sm-6 col-md-4">
            <label className="form-label">Remarks</label>
            <InputField
              placeholder="Enter Remarks"
              value={formData.remarks}
              onChange={(e) => handleFormChange("remarks", e.target.value)}
            />
            <p className="text-end mb-0 remark">
              {formData.remarks ? formData.remarks.length : 0}/500
            </p>
          </div>
        </div>
        <div className="text-end mt-3">
          <Button text="Create Enquiry" variant="primary" type="submit" />
        </div>
      </form>
      {/* Confirm Modal */}
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to Create the enquiry?</Modal.Body>
        <Modal.Footer>
          <Button
            text="Cancel"
            variant="secondary"
            onClick={() => setShowConfirm(false)}
          />
          <Button text="Confirm" variant="primary" onClick={handleConfirm} />
        </Modal.Footer>
      </Modal>
 
      {/* Success Modal */}
      <Modal show={showSuccess} onHide={handleSuccessClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Enquiry created successfully!</Modal.Body>
        <Modal.Footer>
          <Button text="OK" variant="success" onClick={handleSuccessClose} />
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default CreateEnquirySales;